import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/alerts'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  running: false,
  open: false
})

export default handleActions({
  [combineActions(Actions.showAlertDialog, Actions.showCreateAlertDialog)]: state => state.set('open', true),
  [Actions.hideAlertDialog]: state => state.set('open', false),

  [Actions.saveAlertStart]: state => state.set('running', true),
  [Actions.saveAlertSuccess]: state => state.set('running', false),
  [Actions.saveAlertError]: state => state.set('running', false),

  [AppActions.resetState]: () => initialState
}, initialState)
